var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"6"}},[_c('v-skeleton-loader',{attrs:{"type":"article"}})],1),_c('v-col',{attrs:{"cols":"6"}},[_c('v-skeleton-loader',{attrs:{"type":"article"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }